import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { RequestEnviarCondominioWhiteList } from "types/request/RequestEnviarCondominioWhiteList";

export const usePostEnviarCnpjCondominioWhiteListPartner = () => {
  const onError = () => {
    toast.error("Erro ao enviar condominio para o Partner Bank");
  };

  return usePost<RequestEnviarCondominioWhiteList>({
    url: api.contaDigital.postEnviarCnpjCondominioWhiteListPartner,
    onError,
  });
};
